export default __webpack_public_path__ + "static/media/numbered-list-icon.1c78acef.svg";